// import { GridderJS } from "gridder-js";
require('../../vendor/jquery.gridder.js');

// const gridder = new GridderJS(".gridder", {
//     columns: 3,
//     gap: 15
// });


// import { GridderJS } from "gridder-js";
//
// const gridder = new GridderJS("div#myId", {
//     columns: 4,
//     gap: 15
// });

// Call Gridder
$('.gridder').gridderExpander({
    scroll: true,
    scrollOffset: 30,
    scrollTo: "listitem",                  // panel or listitem
    animationSpeed: 400,
    animationEasing: "easeInOutExpo",
    showNav: false,                      // Show Navigation
    nextText: "Next",                   // Next button text
    prevText: "Previous",               // Previous button text
    closeText: "Close",                 // Close button text
    onStart: function(){
        //Gridder Inititialized
    },
    onContent: function(){
        //Gridder Content Loaded
    },
    onClosed: function(){
        //Gridder Closed
    }
});

function stretchMargins() {

    let offset = ($(window).outerWidth() - $('.container').outerWidth()) / 2;

    //update root var --gridder-width
    if($(window).outerWidth() > 992) {
        document.documentElement.style.setProperty('--gridder-width', 'calc(100% + ' + offset * 2 + 'px)');
        document.documentElement.style.setProperty('--gridder-margins', (0 - offset) + 'px');
    } else {
        document.documentElement.style.setProperty('--gridder-width', '100%');
        document.documentElement.style.setProperty('--gridder-margins', '0');
    }

    // $('.gridder-show').css({
    //     'margin-left': 0 - offset,
    //     'margin-right': 0 - offset,
    //     'width': 'calc(100% + ' + offset * 2 + 'px)'
    // })

}

stretchMargins();
$(window).on('resize', stretchMargins);
